// features/roles/api/roles.api.js
// Capa de API para gestión de roles.
// Reemplaza gradualmente: roles.resource.js (BaseService 'roles')
//
// BaseService:
//   GET    /api/roles          → getAll
//   GET    /api/roles/names    → getNames
//   POST   /api/roles          → create
//   PUT    /api/roles/:id      → update
//   DELETE /api/roles/:id      → remove

import { api } from '../../../api/client';

export const modulesApi = {
 
  /** Lista nombres/ids simplificados (para selects) */
  getNames: () =>
    api.get('/privileges/modules/getNames'),

};
